/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface SetBundleGroupVirtualArticleNoteVisible$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
  virtualArticleNoteKey: KeyType;
}

export function setBundleGroupVirtualArticleNoteVisible(http: HttpClient, rootUrl: string, params: SetBundleGroupVirtualArticleNoteVisible$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setBundleGroupVirtualArticleNoteVisible.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.path('virtualArticleNoteKey', params.virtualArticleNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setBundleGroupVirtualArticleNoteVisible.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes/{virtualArticleNoteKey}/visible';
